import {FileCheck, FileClock, FileExclamationPointIcon, Files, Frown, Meh, Smile, UserCog2, UserMinus2Icon, Users} from 'lucide-react'
import styles from './Summaries.module.css'
import { Link } from 'react-router'
import useSummary from '../../../../hooks/summary/useSummary'

export default function Summaries() {    

    const {summary} = useSummary()

    const cardsProviders = [
        {
            name: 'Total',
            amount: !summary ? "0" : `${summary.providersSummary.total}`,
            Icon: <Users className={`${styles.image} ${styles.black}`}/>
        },
        {
            name: 'Operando',
            amount: !summary ? "0" : `${summary.providersSummary.operating}`,
            Icon: <UserCog2 className={`${styles.image} ${styles.green}`}/>
        },
        {
            name: 'Al dia',
            amount: !summary ? "0" : `${summary.providersSummary.compliant}`,
            Icon: <Smile className={`${styles.image} ${styles.green}`}/>
        },
        {
            name: 'En riesgo',
            amount: !summary ? "0" : `${summary.providersSummary.at_risk}`,
            Icon: <Meh className={`${styles.image} ${styles.yellow}`}/>
        },
        {
            name: 'Incumplidos',
            amount: !summary ? "0" : `${summary.providersSummary.non_compliance}`,
            Icon: <Frown className={`${styles.image} ${styles.red}`}/>
        },
        {
            name: 'Obsoletos',
            amount: !summary ? "0" : `${summary.providersSummary.obsoletes}`,
            Icon: <UserMinus2Icon className={`${styles.image} ${styles.gray}`}/>
        }
    ]

     const cardsCompliances = [
        {
            name: 'Total',
            amount: !summary ? "0" : `${summary.complianceSummary.total}`,
            Icon: <Files className={`${styles.image} ${styles.black}`}/>
        },
        {
            name: 'Vigentes',
            amount: !summary ? "0" : `${summary.complianceSummary.current}`,
            Icon: <FileCheck className={`${styles.image} ${styles.green}`}/>
        },
        {
            name: 'En riesgo',
            amount: !summary ? "0" : `${summary.complianceSummary.at_risk}`,
            Icon: <FileClock className={`${styles.image} ${styles.yellow}`}/>
        },
        {
            name: 'Expirados',
            amount: !summary ? "0" : `${summary.complianceSummary.expired}`,
            Icon: <FileExclamationPointIcon className={`${styles.image} ${styles.red}`}/>
        },
        {
            name: 'Entregados',
            amount: !summary ? "0" : `${summary.complianceSummary.submitted}`,
            Icon: <FileCheck className={`${styles.image} ${styles.green}`}/>
        },
        {
            name: 'Pendientes',
            amount: !summary ? "0" : `${summary.complianceSummary.pending}`,
            Icon: <FileExclamationPointIcon className={`${styles.image} ${styles.red}`}/>
        },
    ]

    return (
        <div className={styles.container}>        
            <div className={styles.cardscontainer}>
                <span className={styles.title}>
                    Resumen de proveedores:
                </span>

                <div className={styles.cards}>
                    {
                        cardsProviders.map((card, index) => (
                            <Link to={'../manage'} key={`card-${index}`} className={`${styles.card}`}>
                                <div className={styles.text}>
                                    <span className={styles.label}>{card.name}</span>
                                    <span className={styles.counter}>{card.amount}</span>
                                </div>
                                {card.Icon}
                            </Link>
                        ))
                    }
                </div>
            </div>    

            <div className={styles.cardscontainer}>
                <span className={styles.title}>
                    Resumen de cumplimiento:
                </span>

                <div className={styles.cards}>
                    {
                        cardsCompliances.map((card, index) => (
                            <Link to={'../manage'} key={`card-${index}`} className={`${styles.card}`}>
                                <div className={styles.text}>
                                    <span className={styles.label}>{card.name}</span>
                                    <span className={styles.counter}>{card.amount}</span>
                                </div>
                                {card.Icon}
                            </Link>
                        ))
                    }
                </div>
            </div>
                    
        </div>
    )
}
